import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import bubble from "../../assets/at-details/bubble.png";
import heart from "../../assets/heart.png";

export const BubbleUp: React.FC = () => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleBubbleClick = () => {
    navigate("/om-oss#kontakt");
  };

  return (
    <BubbleContainer
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleBubbleClick}
    >
      <Bubble src={bubble} alt="Bubble" />
      <BubbleText>Säg hej till oss!</BubbleText>
      {isHovered && <Icon src={heart} alt="flying heart" />}
    </BubbleContainer>
  );
};

// Bubblestyling
const liftUp = keyframes`
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  100% {
    transform: translate(-3px, -3px) rotate(3deg);
  }
`;

const landSoftly = keyframes`
  0% {
    transform: translate(-3px, -3px) rotate(3deg);
  }
  100% {
    transform: translate(0, 0) rotate(0deg);
  }
`;

const flyUpSShape = keyframes`
 0% {
    transform: translate(0, 0) rotate(40deg);
    opacity: 1;
  }
  12.5% {
    transform: translate(-5px, -10px) rotate(35deg);
  }
  25% {
    transform: translate(-10px, -20px) rotate(30deg);
  }
  37.5% {
    transform: translate(0px, -25px) rotate(25deg);
  }
  50% {
    transform: translate(10px, -30px) rotate(20deg);
  }
  62.5% {
    transform: translate(0px, -40px) rotate(15deg);
  }
  75% {
    transform: translate(-10px, -50px) rotate(10deg);
  }
  87.5% {
    transform: translate(0px, -60px) rotate(5deg);
  }
  100% {
    transform: translate(10px, -70px) rotate(0deg);
    opacity: 0;
  }
`;

const Bubble = styled.img`
  width: 100px;
  margin-top: 30px;
  transition: transform 0.8s;
  transform: rotate(-80deg);

  @media (min-width: 424px) {
    transform: rotate(-5deg);
  }

  @media (min-width: 768px) {
    width: 160px;
    transform: rotate(-5deg);
  }

  @media (min-width: 1024) {
    width: 190px;
    transform: rotate(-5deg);
  }
`;

const Icon = styled.img`
  position: absolute;
  top: 0;
  left: 80%;
  transform: translateX(-50%);
  opacity: 0;
  transition:
    transform 0.5s,
    opacity 0.3s;
  width: 40px;
`;

const BubbleText = styled.p`
  position: absolute;
  z-index: 1;
  color: var(--mainlight);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 2px;
  text-align: center;
  pointer-events: auto;
  text-decoration: none;
  width: 80px;
  margin-top: 30px;

  @media (min-width: 768px) {
    font-size: 26px;
    line-height: 38px;
    width: 100px;
  }
`;

const BubbleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  position: relative;
  margin: 10px 8px;
  align-self: flex-end;

  &:hover ${Bubble}, &:hover ${BubbleText} {
    animation:
      ${liftUp} 0.3s forwards,
      ${landSoftly} 0.3s 0.3s forwards;
  }

  &:hover ${Icon} {
    animation: ${flyUpSShape} 0.8s forwards;
  }

  /* Tablet */
  @media (min-width: 768px) {
    margin-top: -30px;
    align-self: center;
  }

  /* Desktop */
  @media (min-width: 1024px) {
    margin: 0;
  }
`;
